<template lang="pug">
div
	#modal-promotion01.modal.modal-promotion.fade
		.modal-dialog.modal-dialog-centered.modal-fullscreen-lg-down.modal-lg
			.modal-content
				.modal-header
					.modal-header-title {{ $t('ui.promotion_details') }}
					a(href='javascript:void(0)' data-bs-dismiss='modal')
						.btn-back
							i.fa-solid.fa-left-long.me-1
							| {{$t('ui.back')}}
				.modal-body
					.promotion-detail-wrapper
						.promotion-detail-banner
							img.img-fluid(src='img/promotion/welcome_slot.jpg')
						.promotion-detail-content
							.table-responsive
								table.table.table-new
									thead
										tr
											th {{$t('ui.promo_text.promo1.table.header1')}}
											th {{$t('ui.promo_text.promo1.table.header2')}}
											th {{$t('ui.promo_text.promo1.table.header3')}}
											th {{$t('ui.promo_text.promo1.table.header4')}}
											th {{$t('ui.promo_text.promo1.table.header5')}}
									tbody
										tr
											td 30,000
											td 100%
											td 30,000
											td 60,000
											td 5x
										tr
											td 50,000
											td 100%
											td 50,000
											td 100,000
											td 5x
										tr
											td 100,000
											td 100%
											td 100,000
											td 200,000
											td 5x
										tr
											td 150,000
											td 100%
											td 150,000
											td 300,000
											td 5x
										tr
											td 200,000
											td 100%
											td 200,000
											td 400,000
											td 5x
										tr
											td 250,000
											td 100%
											td 250,000
											td 500,000
											td 5x
										tr
											td 300,000
											td 100%
											td 300,000
											td 600,000
											td 5x
							ol
								li {{$t('ui.promo_text.promo1.desc1')}}
								li {{$t('ui.promo_text.promo1.desc2')}}
								li {{$t('ui.promo_text.promo1.desc3')}}
								li {{$t('ui.promo_text.promo1.desc4')}}
						.promotion-detail-footer
							a(href="javascript(void)" data-bs-dismiss='modal')
								.btn-main.btn-promotion
									.btn-promotion-text {{$t('ui.close')}}
									.btn-promotion-icon
										img(src='img/icon-close.svg')
	#modal-promotion02.modal.modal-promotion.fade
		.modal-dialog.modal-dialog-centered.modal-fullscreen-lg-down.modal-lg
			.modal-content
				.modal-header
					.modal-header-title {{ $t('ui.promotion_details') }}
					a(href="javascript(void)" data-bs-dismiss='modal')
						.btn-back
							i.fa-solid.fa-left-long.me-1
							| {{$t('ui.back')}}
				.modal-body
					.promotion-detail-wrapper
						.promotion-detail-banner
							img.img-fluid(src='img/promotion/xmas.jpg')
						.promotion-detail-content
							ol
								li {{$t('ui.promo_text.promo2.desc1')}}
								li {{$t('ui.promo_text.promo2.desc2')}}
								li {{$t('ui.promo_text.promo2.desc3')}}
								li {{$t('ui.promo_text.promo2.desc4')}}
								li {{$t('ui.promo_text.promo2.desc5')}}
						.promotion-detail-footer
							a(href="javascript(void)" data-bs-dismiss='modal')
								.btn-main.btn-promotion
									.btn-promotion-text {{$t('ui.close')}}
									.btn-promotion-icon
										img(src='img/icon-close.svg')
	#modal-promotion03.modal.modal-promotion.fade
		.modal-dialog.modal-dialog-centered.modal-fullscreen-lg-down.modal-lg
			.modal-content
				.modal-header
					.modal-header-title {{ $t('ui.promotion_details') }}
					a(href="javascript(void)" data-bs-dismiss='modal')
						.btn-back
							i.fa-solid.fa-left-long.me-1
							| {{$t('ui.back')}}
				.modal-body
					.promotion-detail-wrapper
						.promotion-detail-banner
							img.img-fluid(src='img/promotion/regular.jpg')
						.promotion-detail-content
							ol
								li {{$t('ui.promo_text.promo3.desc1')}}
									div {{$t('ui.promo_text.promo3.desc1_1')}}
									div {{$t('ui.promo_text.promo3.desc1_2')}}
									div {{$t('ui.promo_text.promo3.desc1_3')}}
						.promotion-detail-content
							p
								b {{$t('ui.promo_text.promo3.tnc')}}
							ol
								li {{$t('ui.promo_text.promo3.tnc_desc')}}
								
						.promotion-detail-footer
							a(href="javascript(void)" data-bs-dismiss='modal')
								.btn-main.btn-promotion
									.btn-promotion-text {{$t('ui.close')}}
									.btn-promotion-icon
										img(src='img/icon-close.svg')
	#modal-promotion04.modal.modal-promotion.fade
		.modal-dialog.modal-dialog-centered.modal-fullscreen-lg-down.modal-lg
			.modal-content
				.modal-header
					.modal-header-title {{ $t('ui.promotion_details') }}
					a(href="javascript(void)" data-bs-dismiss='modal')
						.btn-back
							i.fa-solid.fa-left-long.me-1
							| {{$t('ui.back')}}
				.modal-body
					.promotion-detail-wrapper
						.promotion-detail-banner
							img.img-fluid(src='img/promotion/freecredit.jpg')
						.promotion-detail-content
							ol
								li {{$t('ui.promo_text.promo4.desc1')}}
								li {{$t('ui.promo_text.promo4.desc2')}}
								li {{$t('ui.promo_text.promo4.desc3')}}
								li {{$t('ui.promo_text.promo4.desc4')}}
								li {{$t('ui.promo_text.promo4.desc5')}}
								li {{$t('ui.promo_text.promo4.desc6')}}
								li {{$t('ui.promo_text.promo4.desc7')}}
						.promotion-detail-footer
							a(href="javascript(void)" data-bs-dismiss='modal')
								.btn-main.btn-promotion(:class="{'custom-width' : getLanguage === 'en'}" @click="showInfo")
									.btn-promotion-text {{$t('ui.play_now')}}
									//- .btn-promotion-icon
										img(src='img/icon-close.svg')
	#modal-promotion05.modal.modal-promotion.fade
		.modal-dialog.modal-dialog-centered.modal-fullscreen-lg-down.modal-lg
			.modal-content
				.modal-header
					.modal-header-title {{ $t('ui.promotion_details') }}
					a(href="javascript(void)" data-bs-dismiss='modal')
						.btn-back
							i.fa-solid.fa-left-long.me-1
							| {{$t('ui.back')}}
				.modal-body
					.promotion-detail-wrapper
						.promotion-detail-banner
							img.img-fluid(src='img/promotion/daily.jpg')
						.promotion-detail-content
							.table-responsive
								table.table.table-new
									thead
										tr
											th {{$t('ui.promo_text.promo5.table.header1')}}
											th {{$t('ui.promo_text.promo5.table.header2')}}
											th {{$t('ui.promo_text.promo5.table.header3')}}
											th {{$t('ui.promo_text.promo5.table.header4')}}
											th {{$t('ui.promo_text.promo5.table.header5')}}
											th {{$t('ui.promo_text.promo5.table.header6')}}
									tbody
										tr
											td 30,000
											td 10
											td 3,000
											td 33,000
											td 3x
											td 99,000
										tr
											td 50,000
											td 10
											td 5,000
											td 55,000
											td 3x
											td 165,000
										tr
											td 100,000
											td 10
											td 10,000
											td 110,000
											td 3x
											td 330,000
							ol
								li {{$t('ui.promo_text.promo5.desc1')}}
								li {{$t('ui.promo_text.promo5.desc2')}}
								li {{$t('ui.promo_text.promo5.desc3')}}
								li {{$t('ui.promo_text.promo5.desc4')}}
						.promotion-detail-footer
							a(href="javascript(void)" data-bs-dismiss='modal')
								.btn-main.btn-promotion
									.btn-promotion-text {{$t('ui.close')}}
									.btn-promotion-icon
										img(src='img/icon-close.svg')
	#modal-promotion06.modal.modal-promotion.fade
		.modal-dialog.modal-dialog-centered.modal-fullscreen-lg-down.modal-lg
			.modal-content
				.modal-header
					.modal-header-title {{ $t('ui.promotion_details') }}
					a(href="javascript(void)" data-bs-dismiss='modal')
						.btn-back
							i.fa-solid.fa-left-long.me-1
							| {{$t('ui.back')}}
				.modal-body
					.promotion-detail-wrapper
						.promotion-detail-banner
							img.img-fluid(src='img/promotion/casino.jpg')
						.promotion-detail-content
							div {{$t('ui.promo_text.promo6.desc1')}}
							div {{$t('ui.promo_text.promo6.desc2')}}
							div {{$t('ui.promo_text.promo6.desc3')}}
							div {{$t('ui.promo_text.promo6.desc4')}}
						.promotion-detail-content
							p
								b {{$t('ui.promo_text.promo6.tnc')}}
							ol
								li {{$t('ui.promo_text.promo6.tnc1')}}
								li {{$t('ui.promo_text.promo6.tnc2')}} 
								li {{$t('ui.promo_text.promo6.tnc3')}} 
								li {{$t('ui.promo_text.promo6.tnc4')}} 
								li {{$t('ui.promo_text.promo6.tnc5')}} 
						.promotion-detail-footer
							a(href="javascript(void)" data-bs-dismiss='modal')
								.btn-main.btn-promotion
									.btn-promotion-text {{$t('ui.close')}}
									.btn-promotion-icon
										img(src='img/icon-close.svg')
	#modal-promotion07.modal.modal-promotion.fade
		.modal-dialog.modal-dialog-centered.modal-fullscreen-lg-down.modal-lg
			.modal-content
				.modal-header
					.modal-header-title {{ $t('ui.promotion_details') }}
					a(href="javascript(void)" data-bs-dismiss='modal')
						.btn-back
							i.fa-solid.fa-left-long.me-1
							| {{$t('ui.back')}}
				.modal-body
					.promotion-detail-wrapper
						.promotion-detail-banner
							img.img-fluid(src='img/promotion/referral.jpg')
						.promotion-detail-content
							ol
								li {{$t('ui.promo_text.promo7.desc1')}}
								li {{$t('ui.promo_text.promo7.desc2')}}
								li {{$t('ui.promo_text.promo7.desc3')}}
						.promotion-detail-content
							p
								b {{$t('ui.promo_text.promo7.tnc')}}
							ol
								li {{$t('ui.promo_text.promo7.tnc1')}}
								li {{$t('ui.promo_text.promo7.tnc2')}} 
								li {{$t('ui.promo_text.promo7.tnc3')}} 
								li {{$t('ui.promo_text.promo7.tnc4')}} 
								li {{$t('ui.promo_text.promo7.tnc5')}}
								li {{$t('ui.promo_text.promo7.tnc6')}} 
								li {{$t('ui.promo_text.promo7.tnc7')}} 
								li {{$t('ui.promo_text.promo7.tnc8')}} 
								li {{$t('ui.promo_text.promo7.tnc9')}} 
						.promotion-detail-footer
							a(href="javascript(void)" data-bs-dismiss='modal')
								.btn-main.btn-promotion
									.btn-promotion-text {{$t('ui.close')}}
									.btn-promotion-icon
										img(src='img/icon-close.svg')
	#modal-promotion08.modal.modal-promotion.fade
		.modal-dialog.modal-dialog-centered.modal-fullscreen-lg-down.modal-lg
			.modal-content
				.modal-header
					.modal-header-title {{ $t('ui.promotion_details') }}
					a(href="javascript(void)" data-bs-dismiss='modal')
						.btn-back
							i.fa-solid.fa-left-long.me-1
							| {{$t('ui.back')}}
				.modal-body
					.promotion-detail-wrapper
						.promotion-detail-banner
							img.img-fluid(src='img/promotion/weekly-sb.jpg')
						.promotion-detail-content
							div {{$t('ui.promo_text.promo8.desc1')}}
							div {{$t('ui.promo_text.promo8.desc2')}}
							div {{$t('ui.promo_text.promo8.desc3')}}
							div {{$t('ui.promo_text.promo8.desc4')}}
						.promotion-detail-content
							p
								b {{$t('ui.promo_text.promo8.tnc')}}
							ol
								li {{$t('ui.promo_text.promo8.tnc1')}}
								li {{$t('ui.promo_text.promo8.tnc2')}} 
								li {{$t('ui.promo_text.promo8.tnc3')}} 
								li {{$t('ui.promo_text.promo8.tnc4')}} 
								li {{$t('ui.promo_text.promo8.tnc5')}}
								li {{$t('ui.promo_text.promo8.tnc6')}} 
						.promotion-detail-footer
							a(href="javascript(void)" data-bs-dismiss='modal')
								.btn-main.btn-promotion
									.btn-promotion-text {{$t('ui.close')}}
									.btn-promotion-icon
										img(src='img/icon-close.svg')
	#modal-promotion09.modal.modal-promotion.fade
		.modal-dialog.modal-dialog-centered.modal-fullscreen-lg-down.modal-lg
			.modal-content
				.modal-header
					.modal-header-title {{ $t('ui.promotion_details') }}
					a(href="javascript(void)" data-bs-dismiss='modal')
						.btn-back
							i.fa-solid.fa-left-long.me-1
							| {{$t('ui.back')}}
				.modal-body
					.promotion-detail-wrapper
						.promotion-detail-banner
							img.img-fluid(src='img/promotion/promotion01.jpg')
						//- .promotion-detail-content
							ol
								li 
								li 
							.table-promotion
								tr
									td Deposit Offer
									td Minimum Deposit
									td Prize Amount
								tr
									td 
									td 
									td 
								tr
									td 
									td 
									td 
								tr
									td 
									td 
									td 
								tr
									td 
									td 
									td 
							ol
								li 
								li 
						.promotion-detail-footer
							a(href="javascript(void)" data-bs-dismiss='modal')
								.btn-main.btn-promotion
									.btn-promotion-text {{$t('ui.close')}}
									.btn-promotion-icon
										img(src='img/icon-close.svg')

</template>
<script>
export default {
	computed:{
		isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
		getLanguage() {
      return this.$store.getters.language || "en"
    },
	},
	methods:{
		showInfo(){
			$('#modal-promotion04').modal('hide')
			if(this.isLoggedIn){
				this.$router.push("/slot").catch(error =>{})
			}else{
				this.$router.push("/login").catch(error =>{})
			}
		}
	}
}
</script>
<style lang="scss" scoped>
.custom-width{
	width: 178px;
}
</style>